import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from '../locales/en.json';
import translationFR from '../locales/fr.json';
import translationDUTCH from '../locales/dutch.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  dutch: {
    translation: translationDUTCH
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    // default as english
    fallbackLng: "en",
    react: {
        useSuspense: false
    },
    interpolation: {
      escapeValue: false
    }
});

export default i18n;